import { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  it: {
    // Navigation
    home: 'Home',
    dashboard: 'Dashboard',
    richieste: 'Richieste',
    mappa: 'Mappa',
    profilo: 'Profilo',
    login: 'Accedi',
    registrati: 'Registrati',
    esci: 'Esci',
    
    // Home
    segnala_emergenza: 'Segnala un\'emergenza',
    segnala_desc: 'La tua richiesta può salvare una vita. Invia aiuto in pochi secondi.',
    cosa_ti_serve: 'Cosa ti serve?',
    posizione_attuale: 'Posizione attuale',
    priorita: 'Priorità',
    invia_emergenza: 'Invia emergenza',
    invio_anonimo: 'I tuoi dati sono protetti. Puoi inviare in forma anonima.',
    
    // Categories
    richiesta_aiuto: 'Richiesta aiuto',
    intervento_urgente: 'Intervento urgente',
    sfollati: 'Sfollati',
    rifugio: 'Rifugio',
    farmaci: 'Farmaci',
    aiuto_umanitario: 'Aiuti umanitari',
    cibo: 'Cibo',
    emergenza_medica: 'Emergenza medica',
    acqua_igiene: 'Acqua e igiene',
    protezione_minori: 'Protezione minori',
    evacuazione_trasporto: 'Evacuazione/Trasporto',
    persone_scomparse: 'Persone scomparse',
    danni_infrastrutturali: 'Danni infrastrutturali',
    blackout_comunicazioni: 'Blackout comunicazioni',
    checkin_sto_bene: 'Check-in "Sto bene"',
    altro: 'Altro',
    
    // Priority
    critica: 'Critica',
    alta: 'Alta',
    media: 'Media',
    bassa: 'Bassa',
    
    // Status
    nuova: 'Nuova',
    in_corso: 'In corso',
    assegnata: 'Assegnata',
    risolta: 'Risolta',
    chiusa: 'Chiusa',
    
    // Dashboard
    dashboard_operativa: 'Dashboard Operativa',
    in_tempo_reale: 'In tempo reale',
    richieste_oggi: 'Richieste oggi',
    interventi_in_corso: 'Interventi in corso',
    richieste_totali: 'Richieste totali',
    richieste_risolte: 'Richieste risolte',
    richieste_recenti: 'Richieste recenti',
    vedi_tutte: 'Vedi tutte',
    mappa_live: 'Mappa live',
    attivita_in_corso: 'Attività in corso',
    statistiche: 'Statistiche',
    filtra: 'Filtra',
    tutti: 'Tutti',
    
    // Form
    descrizione: 'Descrizione',
    descrizione_placeholder: 'Descrivi la tua emergenza...',
    indirizzo: 'Indirizzo',
    nome: 'Nome',
    cognome: 'Cognome',
    email: 'Email',
    password: 'Password',
    telefono: 'Telefono',
    codice_fiscale: 'Codice Fiscale',
    documento_identita: 'Documento d\'identità',
    anonimo: 'Invio anonimo',
    nome_richiedente: 'Nome richiedente',
    numero_persone: 'Numero persone',
    note_aggiuntive: 'Note aggiuntive',
    invia: 'Invia',
    annulla: 'Annulla',
    salva: 'Salva',
    
    // Auth
    accedi_account: 'Accedi al tuo account',
    crea_account: 'Crea un account',
    non_hai_account: 'Non hai un account?',
    hai_gia_account: 'Hai già un account?',
    
    // Check-in
    checkin_title: 'Check-in "Sto bene"',
    checkin_desc: 'Fai sapere ai tuoi cari che stai bene',
    messaggio: 'Messaggio',
    
    // General
    caricamento: 'Caricamento...',
    errore: 'Errore',
    successo: 'Successo',
    conferma: 'Conferma',
    nessun_risultato: 'Nessun risultato',
    aggiorna_stato: 'Aggiorna stato',
    note_operatore: 'Note operatore',
    offline_mode: 'Modalità offline - I dati verranno sincronizzati',
    richiesta_inviata: 'Richiesta inviata con successo!',
    richiesta_salvata: 'Richiesta salvata localmente',
    seleziona_categoria: 'Seleziona una categoria',
    fa: 'fa',
    min: 'min',
  },
  en: {
    home: 'Home',
    dashboard: 'Dashboard',
    richieste: 'Requests',
    mappa: 'Map',
    profilo: 'Profile',
    login: 'Login',
    registrati: 'Register',
    esci: 'Logout',
    segnala_emergenza: 'Report an emergency',
    segnala_desc: 'Your request can save a life. Send help in seconds.',
    cosa_ti_serve: 'What do you need?',
    posizione_attuale: 'Current position',
    priorita: 'Priority',
    invia_emergenza: 'Send emergency',
    invio_anonimo: 'Your data is protected. You can send anonymously.',
    richiesta_aiuto: 'Help request',
    intervento_urgente: 'Urgent intervention',
    sfollati: 'Displaced',
    rifugio: 'Shelter',
    farmaci: 'Medicine',
    aiuto_umanitario: 'Humanitarian aid',
    cibo: 'Food',
    emergenza_medica: 'Medical emergency',
    acqua_igiene: 'Water & hygiene',
    protezione_minori: 'Child protection',
    evacuazione_trasporto: 'Evacuation/Transport',
    persone_scomparse: 'Missing persons',
    danni_infrastrutturali: 'Infrastructure damage',
    blackout_comunicazioni: 'Communication blackout',
    checkin_sto_bene: 'Check-in "I\'m OK"',
    altro: 'Other',
    critica: 'Critical',
    alta: 'High',
    media: 'Medium',
    bassa: 'Low',
    nuova: 'New',
    in_corso: 'In progress',
    assegnata: 'Assigned',
    risolta: 'Resolved',
    chiusa: 'Closed',
    dashboard_operativa: 'Operations Dashboard',
    in_tempo_reale: 'Real-time',
    richieste_oggi: 'Requests today',
    interventi_in_corso: 'Active interventions',
    richieste_totali: 'Total requests',
    richieste_risolte: 'Resolved requests',
    richieste_recenti: 'Recent requests',
    vedi_tutte: 'View all',
    mappa_live: 'Live map',
    attivita_in_corso: 'Active operations',
    statistiche: 'Statistics',
    filtra: 'Filter',
    tutti: 'All',
    descrizione: 'Description',
    descrizione_placeholder: 'Describe your emergency...',
    indirizzo: 'Address',
    nome: 'Name',
    cognome: 'Surname',
    email: 'Email',
    password: 'Password',
    telefono: 'Phone',
    codice_fiscale: 'Tax Code',
    documento_identita: 'Identity Document',
    anonimo: 'Anonymous submission',
    nome_richiedente: 'Requester name',
    numero_persone: 'Number of people',
    note_aggiuntive: 'Additional notes',
    invia: 'Submit',
    annulla: 'Cancel',
    salva: 'Save',
    accedi_account: 'Login to your account',
    crea_account: 'Create an account',
    non_hai_account: "Don't have an account?",
    hai_gia_account: 'Already have an account?',
    checkin_title: 'Check-in "I\'m OK"',
    checkin_desc: 'Let your loved ones know you\'re safe',
    messaggio: 'Message',
    caricamento: 'Loading...',
    errore: 'Error',
    successo: 'Success',
    conferma: 'Confirm',
    nessun_risultato: 'No results',
    aggiorna_stato: 'Update status',
    note_operatore: 'Operator notes',
    offline_mode: 'Offline mode - Data will be synced',
    richiesta_inviata: 'Request submitted successfully!',
    richiesta_salvata: 'Request saved locally',
    seleziona_categoria: 'Select a category',
    fa: 'ago',
    min: 'min',
  },
  fr: {
    home: 'Accueil',
    dashboard: 'Tableau de bord',
    richieste: 'Demandes',
    mappa: 'Carte',
    profilo: 'Profil',
    login: 'Connexion',
    registrati: 'S\'inscrire',
    esci: 'Déconnexion',
    segnala_emergenza: 'Signaler une urgence',
    segnala_desc: 'Votre demande peut sauver une vie. Envoyez de l\'aide en quelques secondes.',
    cosa_ti_serve: 'De quoi avez-vous besoin ?',
    posizione_attuale: 'Position actuelle',
    priorita: 'Priorité',
    invia_emergenza: 'Envoyer urgence',
    invio_anonimo: 'Vos données sont protégées. Vous pouvez envoyer anonymement.',
    richiesta_aiuto: 'Demande d\'aide',
    intervento_urgente: 'Intervention urgente',
    sfollati: 'Déplacés',
    rifugio: 'Refuge',
    farmaci: 'Médicaments',
    aiuto_umanitario: 'Aide humanitaire',
    cibo: 'Nourriture',
    emergenza_medica: 'Urgence médicale',
    acqua_igiene: 'Eau et hygiène',
    protezione_minori: 'Protection des mineurs',
    evacuazione_trasporto: 'Évacuation/Transport',
    persone_scomparse: 'Personnes disparues',
    danni_infrastrutturali: 'Dégâts infrastructurels',
    blackout_comunicazioni: 'Panne de communication',
    checkin_sto_bene: 'Check-in "Je vais bien"',
    altro: 'Autre',
    critica: 'Critique',
    alta: 'Haute',
    media: 'Moyenne',
    bassa: 'Basse',
    nuova: 'Nouvelle',
    in_corso: 'En cours',
    assegnata: 'Assignée',
    risolta: 'Résolue',
    chiusa: 'Fermée',
    dashboard_operativa: 'Tableau de bord opérationnel',
    in_tempo_reale: 'Temps réel',
    richieste_oggi: 'Demandes aujourd\'hui',
    interventi_in_corso: 'Interventions en cours',
    richieste_totali: 'Demandes totales',
    richieste_risolte: 'Demandes résolues',
    richieste_recenti: 'Demandes récentes',
    vedi_tutte: 'Voir toutes',
    mappa_live: 'Carte en direct',
    attivita_in_corso: 'Activités en cours',
    statistiche: 'Statistiques',
    filtra: 'Filtrer',
    tutti: 'Tous',
    descrizione: 'Description',
    descrizione_placeholder: 'Décrivez votre urgence...',
    indirizzo: 'Adresse',
    nome: 'Prénom',
    cognome: 'Nom',
    email: 'Email',
    password: 'Mot de passe',
    telefono: 'Téléphone',
    codice_fiscale: 'Code fiscal',
    documento_identita: 'Pièce d\'identité',
    anonimo: 'Envoi anonyme',
    nome_richiedente: 'Nom du demandeur',
    numero_persone: 'Nombre de personnes',
    note_aggiuntive: 'Notes supplémentaires',
    invia: 'Envoyer',
    annulla: 'Annuler',
    salva: 'Sauvegarder',
    accedi_account: 'Connectez-vous à votre compte',
    crea_account: 'Créer un compte',
    non_hai_account: 'Pas de compte ?',
    hai_gia_account: 'Déjà un compte ?',
    checkin_title: 'Check-in "Je vais bien"',
    checkin_desc: 'Faites savoir à vos proches que vous allez bien',
    messaggio: 'Message',
    caricamento: 'Chargement...',
    errore: 'Erreur',
    successo: 'Succès',
    conferma: 'Confirmer',
    nessun_risultato: 'Aucun résultat',
    aggiorna_stato: 'Mettre à jour le statut',
    note_operatore: 'Notes opérateur',
    offline_mode: 'Mode hors ligne - Les données seront synchronisées',
    richiesta_inviata: 'Demande envoyée avec succès !',
    richiesta_salvata: 'Demande sauvegardée localement',
    seleziona_categoria: 'Sélectionnez une catégorie',
    fa: 'il y a',
    min: 'min',
  },
  zh: {
    home: '首页',
    dashboard: '控制台',
    richieste: '请求',
    mappa: '地图',
    profilo: '个人资料',
    login: '登录',
    registrati: '注册',
    esci: '退出',
    segnala_emergenza: '报告紧急情况',
    segnala_desc: '您的请求可以挽救生命。几秒钟内发送求助。',
    cosa_ti_serve: '您需要什么？',
    posizione_attuale: '当前位置',
    priorita: '优先级',
    invia_emergenza: '发送紧急请求',
    invio_anonimo: '您的数据受到保护。可以匿名发送。',
    richiesta_aiuto: '求助请求',
    intervento_urgente: '紧急干预',
    sfollati: '流离失所者',
    rifugio: '避难所',
    farmaci: '药品',
    aiuto_umanitario: '人道主义援助',
    cibo: '食物',
    emergenza_medica: '医疗紧急情况',
    acqua_igiene: '水和卫生',
    protezione_minori: '儿童保护',
    evacuazione_trasporto: '疏散/运输',
    persone_scomparse: '失踪人员',
    danni_infrastrutturali: '基础设施损坏',
    blackout_comunicazioni: '通信中断',
    checkin_sto_bene: '报平安',
    altro: '其他',
    critica: '紧急',
    alta: '高',
    media: '中',
    bassa: '低',
    nuova: '新建',
    in_corso: '进行中',
    assegnata: '已分配',
    risolta: '已解决',
    chiusa: '已关闭',
    dashboard_operativa: '运营控制台',
    in_tempo_reale: '实时',
    richieste_oggi: '今日请求',
    interventi_in_corso: '进行中的干预',
    richieste_totali: '总请求数',
    richieste_risolte: '已解决请求',
    richieste_recenti: '最近请求',
    vedi_tutte: '查看全部',
    mappa_live: '实时地图',
    attivita_in_corso: '进行中的活动',
    statistiche: '统计',
    filtra: '筛选',
    tutti: '全部',
    descrizione: '描述',
    descrizione_placeholder: '描述您的紧急情况...',
    indirizzo: '地址',
    nome: '名字',
    cognome: '姓氏',
    email: '电子邮件',
    password: '密码',
    telefono: '电话',
    codice_fiscale: '税号',
    documento_identita: '身份证件',
    anonimo: '匿名发送',
    nome_richiedente: '请求人姓名',
    numero_persone: '人数',
    note_aggiuntive: '附加说明',
    invia: '提交',
    annulla: '取消',
    salva: '保存',
    accedi_account: '登录您的账户',
    crea_account: '创建账户',
    non_hai_account: '没有账户？',
    hai_gia_account: '已有账户？',
    checkin_title: '报平安',
    checkin_desc: '让亲人知道您安全',
    messaggio: '消息',
    caricamento: '加载中...',
    errore: '错误',
    successo: '成功',
    conferma: '确认',
    nessun_risultato: '无结果',
    aggiorna_stato: '更新状态',
    note_operatore: '操作员备注',
    offline_mode: '离线模式 - 数据将自动同步',
    richiesta_inviata: '请求提交成功！',
    richiesta_salvata: '请求已本地保存',
    seleziona_categoria: '选择类别',
    fa: '前',
    min: '分钟',
  },
  ru: {
    home: 'Главная',
    dashboard: 'Панель управления',
    richieste: 'Запросы',
    mappa: 'Карта',
    profilo: 'Профиль',
    login: 'Войти',
    registrati: 'Регистрация',
    esci: 'Выйти',
    segnala_emergenza: 'Сообщить о ЧС',
    segnala_desc: 'Ваш запрос может спасти жизнь. Отправьте помощь за секунды.',
    cosa_ti_serve: 'Что вам нужно?',
    posizione_attuale: 'Текущее местоположение',
    priorita: 'Приоритет',
    invia_emergenza: 'Отправить экстренный запрос',
    invio_anonimo: 'Ваши данные защищены. Можно отправить анонимно.',
    richiesta_aiuto: 'Запрос помощи',
    intervento_urgente: 'Срочное вмешательство',
    sfollati: 'Перемещённые лица',
    rifugio: 'Убежище',
    farmaci: 'Лекарства',
    aiuto_umanitario: 'Гуманитарная помощь',
    cibo: 'Еда',
    emergenza_medica: 'Медицинская ЧС',
    acqua_igiene: 'Вода и гигиена',
    protezione_minori: 'Защита детей',
    evacuazione_trasporto: 'Эвакуация/Транспорт',
    persone_scomparse: 'Пропавшие без вести',
    danni_infrastrutturali: 'Повреждение инфраструктуры',
    blackout_comunicazioni: 'Отключение связи',
    checkin_sto_bene: 'Отметка "Я в порядке"',
    altro: 'Другое',
    critica: 'Критический',
    alta: 'Высокий',
    media: 'Средний',
    bassa: 'Низкий',
    nuova: 'Новый',
    in_corso: 'В процессе',
    assegnata: 'Назначен',
    risolta: 'Решён',
    chiusa: 'Закрыт',
    dashboard_operativa: 'Оперативная панель',
    in_tempo_reale: 'В реальном времени',
    richieste_oggi: 'Запросы сегодня',
    interventi_in_corso: 'Активные вмешательства',
    richieste_totali: 'Всего запросов',
    richieste_risolte: 'Решённые запросы',
    richieste_recenti: 'Последние запросы',
    vedi_tutte: 'Смотреть все',
    mappa_live: 'Карта в реальном времени',
    attivita_in_corso: 'Текущие операции',
    statistiche: 'Статистика',
    filtra: 'Фильтр',
    tutti: 'Все',
    descrizione: 'Описание',
    descrizione_placeholder: 'Опишите вашу ЧС...',
    indirizzo: 'Адрес',
    nome: 'Имя',
    cognome: 'Фамилия',
    email: 'Эл. почта',
    password: 'Пароль',
    telefono: 'Телефон',
    codice_fiscale: 'Налоговый код',
    documento_identita: 'Удостоверение личности',
    anonimo: 'Анонимная отправка',
    nome_richiedente: 'Имя заявителя',
    numero_persone: 'Количество людей',
    note_aggiuntive: 'Дополнительные заметки',
    invia: 'Отправить',
    annulla: 'Отмена',
    salva: 'Сохранить',
    accedi_account: 'Войти в аккаунт',
    crea_account: 'Создать аккаунт',
    non_hai_account: 'Нет аккаунта?',
    hai_gia_account: 'Уже есть аккаунт?',
    checkin_title: 'Отметка "Я в порядке"',
    checkin_desc: 'Сообщите близким, что вы в безопасности',
    messaggio: 'Сообщение',
    caricamento: 'Загрузка...',
    errore: 'Ошибка',
    successo: 'Успешно',
    conferma: 'Подтвердить',
    nessun_risultato: 'Нет результатов',
    aggiorna_stato: 'Обновить статус',
    note_operatore: 'Заметки оператора',
    offline_mode: 'Офлайн-режим - Данные будут синхронизированы',
    richiesta_inviata: 'Запрос отправлен успешно!',
    richiesta_salvata: 'Запрос сохранён локально',
    seleziona_categoria: 'Выберите категорию',
    fa: 'назад',
    min: 'мин',
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('lifelink_lang') || 'it';
  });

  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations['it']?.[key] || key;
  }, [lang]);

  const switchLang = useCallback((newLang) => {
    setLang(newLang);
    localStorage.setItem('lifelink_lang', newLang);
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, t, switchLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
